'use client';
import dynamic from 'next/dynamic';
import { ComponentType, FC } from 'react';
import { components } from '@/types/strapi';

interface PopupDynamicZoneManagerProps {
	dynamicZone: NonNullable<
		components['schemas']['SharedPopupContentComponent']['dynamic_zone']
	>;
	locale: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const componentMapping: Record<string, ComponentType<any>> = {
	'popup.single-column-age-verification': dynamic(
		() =>
			import('./SingleColumnAgeVerification').then(
				mod => mod.SingleColumnAgeVerification,
			),
		{ ssr: false },
	),
	'popup.single-column-discount-offer': dynamic(
		() =>
			import('./SingleColumnDiscountOffer').then(
				mod => mod.SingleColumnDiscountOffer,
			),
		{ ssr: false },
	),
	'popup.single-column-exclusive-sale': dynamic(
		() =>
			import('./SingleColumnExclusiveSale').then(
				mod => mod.SingleColumnExclusiveSale,
			),
		{ ssr: false },
	),
	'popup.single-column-newsletter-signup': dynamic(
		() =>
			import('./SingleColumnNewsletterSignup').then(
				mod => mod.SingleColumnNewsletterSignup,
			),
		{ ssr: false },
	),
	'popup.single-column-product-feature': dynamic(
		() =>
			import('./SingleColumnProductFeature').then(
				mod => mod.SingleColumnProductFeature,
			),
		{ ssr: false },
	),
	'popup.single-column-product-promotion': dynamic(
		() =>
			import('./SingleColumnProductPromotion').then(
				mod => mod.SingleColumnProductPromotion,
			),
		{ ssr: false },
	),
	'popup.two-column-image-discount-offer': dynamic(
		() =>
			import('./TwoColumnImageDiscountOffer').then(
				mod => mod.TwoColumnImageDiscountOffer,
			),
		{ ssr: false },
	),

	'popup.two-column-image-newsletter-signup': dynamic(
		() =>
			import('./TwoColumnImageNewsletterSignup').then(
				mod => mod.TwoColumnImageNewsletterSignup,
			),
		{ ssr: false },
	),
	// 'popup.two-column-image-welcome-message': dynamic(
	// 	() =>
	// 		import('./TwoColumnImageWelcomeMessage').then(
	// 			mod => mod.TwoColumnImageWelcomeMessage,
	// 		),
	// 	{ ssr: false },
	// ),
};

const PopupDynamicZoneManager: FC<PopupDynamicZoneManagerProps> = ({
	dynamicZone,
	locale,
}) => {
	return dynamicZone.map((componentData, index) => {
		const Component =
			componentMapping[
				componentData.__component as keyof typeof componentMapping
			];
		if (!Component) {
			console.warn(
				`No popup component found for: ${componentData.__component}`,
			);
			return null;
		}
		const uniqueKey = `${componentData.__component}-${componentData.id}-${index}`;
		return (
			<Component
				key={uniqueKey}
				content={componentData}
				locale={locale}
			/>
		);
	});
};

export default PopupDynamicZoneManager;
